module.exports = "/currency/assets/16acdb2aef22ae6ce1309ff2a1c18416.png";